<template>
  <tr>
    <td>
      <UserLinkByText :value="item" />
    </td>
    <td>{{rcpCount}}</td>
    <td class="right">{{newsNormal.sendCount}}</td>
    <td class="right">{{newsNormal.receiveByCount}}</td>
    <td class="right">{{newsNormal.readCount}}</td>
    <td class="right">{{newsNormal.readByCount}}</td>
    <td class="right">{{newsRepeat.sendCount}}</td>
    <td class="right">{{newsRepeat.receiveByCount}}</td>
    <td class="right">{{newsRepeat.readCount}}</td>
    <td class="right">{{newsRepeat.readByCount}}</td>
    <td class="right">{{newsCustom.birthdayCount}}</td>
    <td class="right">{{newsCustom.unusedwarningCount}}</td>
    <td class="right">{{newsCustom.newInstall5DaysCount}}</td>
    <td class="right">{{newsCustom.badKeyword3DaysCount}}</td>
    <td class="right">{{newsCustom.dementiaUnused30DaysCount}}</td>
    <td class="right">{{newsCustom.brainUnused7DaysCount}}</td>
    <td class="right">{{newsCustom.mindgymUnused7DaysCount}}</td>
    <td class="right">{{newsCustom.spkUsed2DaysCount}}</td>
    <td class="right">{{newsCustom.spkUsed4DaysCount}}</td>
    <td class="right">{{newsCustom.spkUsed7DaysCount}}</td>
    <td class="right">{{newsCustom.spkUsed15DaysCount}}</td>
    <td class="right">{{newsCustom.spkUsed30DaysCount}}</td>
  </tr>
</template>

<script>
import statsMixin from "$views/Stats/v2/_mixin";
export default {
  mixins: [statsMixin],
  props: {
    item: String,
    rcpCount: Number,
    newsNormal: Object,
    newsRepeat: Object,
    newsCustom: Object
  }
};
</script>